import { render, staticRenderFns } from "./detaile.vue?vue&type=template&id=38279a09&scoped=true"
import script from "./detaile.vue?vue&type=script&lang=js"
export * from "./detaile.vue?vue&type=script&lang=js"
import style0 from "./detaile.vue?vue&type=style&index=0&id=38279a09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38279a09",
  null
  
)

export default component.exports